import { Component } from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './DownloadButton.module.css';
import { DownloadSVG } from '../../../svgComponents/downloadSVG/';

class DownloadButton extends Component {
    getDownloadClassName() {
        const { className, pending } = this.props;

        if (pending) {
            return classNames(className, styles.downloadPending);
        }

        return classNames(className, styles.download);
    }

    handleClick = () => {
        const { onClick, pending } = this.props;

        if (!pending && onClick) {
            onClick();
        }
    };

    render() {
        const { iconOnly } = this.props;

        return (
            <div
                className={this.getDownloadClassName()}
                onClick={this.handleClick}
            >
                {!iconOnly && (
                    <FormattedMessage
                        id="_.ui.download_button"
                        defaultMessage="Download"
                    />
                )}
                <DownloadSVG className={styles.downloadIcon} />
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default DownloadButton;
